import { subcategoriesWithColors } from "@aclymatepackages/subcategories";
import { CategoriesAvatar } from "@aclymatepackages/atoms";

import ViewGraphCardLayout from "../../../../layouts/ViewGraphCard";
import ViewBarChart from "../../../../modules/charts/ViewBarChart";
import EmissionsCustomTooltip from "../../../../modules/charts/EmissionsCustomTooltip";

import { useOfficeStatuses } from "../../../../../helpers/components/offices";
import useDisplayMeasurementSystem from "../../../../../helpers/hooks/displayMeasurementSystem";

const OfficesBarChart = ({ dataArray, setSelectedObject }) => {
  const { carbonUnitLabel } = useDisplayMeasurementSystem();

  const barAreasArray = [
    ...subcategoriesWithColors.map(({ subcategory, color, name }) => ({
      subcategory: subcategory,
      dataKey: subcategory,
      name: `Average Monthly ${name} ${
        subcategory !== "renewable-energy" ? "Emissions" : ""
      }`,
      color,
      customAvatar: <CategoriesAvatar subcategory={subcategory} />,
    })),
  ];

  return (
    <ViewBarChart
      dataType="offices"
      setSelectedObject={setSelectedObject}
      barAreasArray={barAreasArray}
      data={dataArray}
      yLabel={`Monthly ${carbonUnitLabel} of Carbon`}
      tooltipComponent={
        <EmissionsCustomTooltip
          categoriesArray={barAreasArray}
          labelAnnotation="(monthly average)"
          dataArray={dataArray}
        />
      }
    />
  );
};

const OfficesGraph = ({ dataArray, setSelectedObject }) => {
  const officeStatuses = useOfficeStatuses();

  const buildStatusLabelWarningObj = ({ status }) => {
    if (status === "active") {
      return {};
    }

    const statusObj = officeStatuses[status];
    return { status: statusObj };
  };

  const formattedFilteredOffices = dataArray
    .filter(({ status }) => status !== "closed")
    .map(
      ({
        monthlyRecurringEmissions,
        nonRecurringEmissionsAverages,
        totalMonthlyCarbonVolume,
        name,
        id,
        ...otherProps
      }) => ({
        ...monthlyRecurringEmissions,
        ...nonRecurringEmissionsAverages,
        emissionsSumTons: totalMonthlyCarbonVolume,
        label: name,
        id,
        ...buildStatusLabelWarningObj(otherProps),
      })
    );

  const graphs = [
    {
      title: `Monthly Office emissions`,
      type: "bar",
      Graph: OfficesBarChart,
      graphProps: { setSelectedObject },
      sortable: true,
    },
  ];
  return (
    <ViewGraphCardLayout
      dataArray={formattedFilteredOffices}
      subtitle={`NOTE: Closed offices are not shown in the graph since they don't currently contribute to your emissions`}
      graphs={graphs}
      analyticsCta="to see how each of your offices contributes to your monthly emissions"
    />
  );
};
export default OfficesGraph;
